module.exports = new __parcel__URL__("cloud-patient.4df6c278.svg").toString();